import {createContext, useContext, useState} from "react";
import {AuthContext} from "./authContext";
import {API_BASE_URL, API_KEY} from "../config/config";
import axios from "axios";

const VideoContext = createContext(null);

const VideoProvider = ({children}) => {
	const {visitor} = useContext(AuthContext);

	const [videosData, setVideosData] = useState({
		normal: {videos: [], loading: false, page: 1, hasMore: true, initialLoaded: false},
		friends: {videos: [], loading: false, page: 1, hasMore: true, initialLoaded: false},
		vip: {videos: [], loading: false, page: 1, hasMore: true, initialLoaded: false},
	});

	const fetchVideos = async (type, isInitialFetch = false) => {
		if (!visitor) return;

		if (videosData[type].loading === true) return; // Is loading

		if (isInitialFetch && videosData[type].initialLoaded === true) return; // Already loaded

		setVideosData((prevData) => ({
			...prevData,
			[type]: { ...prevData[type], loading: true }
		}));

		try {
			const page = videosData[type].page;
			const apiUrl = `${API_BASE_URL}/videos?type=${type}&page=${page}`;
			const config = {
				method: "get",
				maxBodyLength: Infinity,
				url: apiUrl,
				headers: {
					"XF-Api-Key": API_KEY,
					"XF-Api-User": visitor.user_id,
				},
				withCredentials: true,
			};

			const response = await axios.request(apiUrl, config);
			const newVideos = Object.values(response.data.videos);
			const pagination = response.data.pagination;

			setVideosData((prevData) => ({
				...prevData,
				[type]: {
					videos: [...prevData[type].videos, ...newVideos],
					page: page + 1,
					hasMore: pagination.current_page < pagination.last_page,
					loading: false,
					initialLoaded: true,
				}
			}));
		} catch (error) {
			console.error("Failed to fetch videos:", error);

			setVideosData((prevData) => ({
				...prevData,
				[type]: {
					...prevData[type],
					loading: false,
					initialLoaded: true,
				}
			}));
		}
	}

	const loadMoreVideos = (type) => {
		if (!videosData[type].hasMore || videosData[type].loading)
			return;

		fetchVideos(type, false);
	}

	return (
		<VideoContext.Provider value={{
			...videosData,
			loadMoreVideos,
			fetchVideos,
		}}>
			{children}
		</VideoContext.Provider>
	);
}

export {VideoContext, VideoProvider}